import { render, staticRenderFns } from "./ProcessAnimal.vue?vue&type=template&id=d00ceb32&scoped=true"
import script from "./ProcessAnimal.vue?vue&type=script&lang=ts"
export * from "./ProcessAnimal.vue?vue&type=script&lang=ts"
import style0 from "./ProcessAnimal.vue?vue&type=style&index=0&id=d00ceb32&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d00ceb32",
  null
  
)

export default component.exports